import { TimeBucketName } from '@fabric-ui/components/Table';
import { useAvContext } from '../../../context/AvContextProvider';
import { useCalculatedDimensionsList, useMeasurementsList } from '../../Reports/hooks';

export const useGetDisplayName = (activeProjName: string) => {
  const { aggProjs, fieldMap } = useAvContext().accountEntities;
  const { data: measurements = [] } = useMeasurementsList({
    entityName: aggProjs[activeProjName].entityTypeId.name,
    filterFunc: v => v.context.includes(aggProjs[activeProjName].entityTypeId.name),
  });
  const { data: calculatedDimensions = [] } = useCalculatedDimensionsList({
    projectionName: activeProjName,
    filterFunc: v => v.context?.some(ctx => ctx.name === activeProjName),
  });
  return (fieldName?: string | null | undefined | number): string | null | undefined | number =>
    !fieldName
      ? fieldName
      : fieldMap[fieldName]?.title ||
        measurements.find(v => v.systemName === fieldName)?.displayName ||
        calculatedDimensions.find(v => v.systemName === fieldName)?.displayName ||
        TimeBucketName[fieldName];
};
